import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();
import akuuu from './assets/akuuu.jpg';
import akuuu1 from './assets/akuuu1.jpg';
import akuuu2 from './assets/akuuu2.jpg';
import akuuu4 from './assets/akuuu4.jpg';
import akuuu5 from './assets/akuuu5.jpg';
import akuuu6 from './assets/akuuu6.jpg';
document.addEventListener('DOMContentLoaded', () => {
  const image = document.getElementById('profile-img');

  // Step 1: Store images in an array
  const images = [akuuu1, akuuu, akuuu2, akuuu4, akuuu5, akuuu6]; // add more if needed
  let currentIndex = 0;

  // Step 2: Set initial image
  image.src = images[currentIndex];

  // Step 3: On click, cycle through the images
  image.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % images.length; // loop to start
    image.src = images[currentIndex];
 

  });
});

